import React, { useEffect, useRef, useState } from 'react';

const LazyVideo = ({ src, alt, style }) => {
    const videoRef = useRef(null);
    const [, setIsVisible] = useState(false);

    useEffect(() => {
        const videoElement = videoRef.current;
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        if (videoElement) {
                            videoElement.play().catch(error => {
                                console.log("Video play failed:", error);
                            });
                        }
                    } else {
                        setIsVisible(false);
                        if (videoElement) {
                            videoElement.pause();
                            videoElement.currentTime = 0;
                        }
                    }
                });
            },
            {
                root: null,
                rootMargin: '50px',
                threshold: 0.1
            }
        );

        if (videoElement) {
            observer.observe(videoElement);
        }

        return () => {
            if (videoElement) {
                observer.unobserve(videoElement);
            }
        };
    }, [setIsVisible]);

    return (
        <video
            ref={videoRef}
            src={src}
            alt={alt}
            style={style}
            muted
            playsInline
            loop
            preload="none"
        />
    );
};

export default LazyVideo; 